module.exports = __webpack_public_path__ + "img/lucianshippinglogo-removebg.936ce213.png";